import { BusinessOperatingSystem } from '@ninety/mobile/platform/api';

import { DiscussionModel } from '../../../models/discussion.models';
import { DiscussionFormMode } from '../../../models/form/discussion-form.model';

export abstract class DiscussionFormBase {
  abstract discussion: DiscussionModel;
  abstract mode: DiscussionFormMode;

  get isMeeting() {
    return this.mode === DiscussionFormMode.Meeting;
  }

  get isManager() {
    return this.mode === DiscussionFormMode.Manager;
  }

  get isManagee() {
    return this.mode === DiscussionFormMode.Managee;
  }

  get isEos() {
    return this.discussion.bos === BusinessOperatingSystem.eos;
  }

  get managerCommentLabel() {
    return `${this.discussion.manager?.metadata?.name?.first ?? ''}'s Comments`;
  }

  get manageeCommentLabel() {
    return `${this.discussion.managee?.metadata?.name?.first ?? ''}'s Comments`;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected onChange: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected onTouched: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
